import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
// import 'bootstrap/dist/js/bootstrap.js';

ReactDOM.render(
 
    <App />
  ,
  document.getElementById('root')
);


